import { useEffect } from "react";

/** Ctrl+K / ⌘K alterna; "/" abre quando ninguém está digitando. Fica fora da busca para ela carregar sob demanda. */
export function useAtalhoBusca(aberta: boolean, aoMudar: (v: boolean) => void) {
  useEffect(() => {
    const tecla = (e: KeyboardEvent) => {
      const alvo = e.target as HTMLElement | null;
      const digitando = !!alvo && (alvo.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(alvo.tagName));
      if ((e.key === "k" || e.key === "K") && (e.metaKey || e.ctrlKey)) { e.preventDefault(); aoMudar(!aberta); }
      else if (e.key === "/" && !digitando && !aberta) { e.preventDefault(); aoMudar(true); }
    };
    window.addEventListener("keydown", tecla);
    return () => window.removeEventListener("keydown", tecla);
  }, [aberta, aoMudar]);
}
